import { render, staticRenderFns } from "./EvaluationgameSeting.vue?vue&type=template&id=0ff68632&scoped=true"
import script from "./EvaluationgameSeting.vue?vue&type=script&lang=js"
export * from "./EvaluationgameSeting.vue?vue&type=script&lang=js"
import style0 from "./EvaluationgameSeting.vue?vue&type=style&index=0&id=0ff68632&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff68632",
  null
  
)

export default component.exports